import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';

import { Button, Select } from '../../../components';
import { short } from '../common/formatting/date';
import { search } from './api';

const GENDER_CHOICES = [
	{ value: '', label: 'Gender' },
	{ value: 'F', label: 'Female' },
	{ value: 'M', label: 'Male' },
];

export default class AcrsSearch extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
	};

	static defaultProps = {
		user: {},
	};

	state = {
		firstName: '',
		lastName: '',
		dob: '',
		gender: '',
		isSearching: false,
	};

	handleSearchClick = async (event) => {
		event.preventDefault();
		this.setState({ isSearching: true });
		try {
			const { status } = await search(this.props.user.get('id'), {
				firstName: this.state.firstName,
				lastName: this.state.lastName,
				dob: isEmpty(this.state.dob)
					? null
					: short(this.state.dob, false, 'yyyyMMdd'),
				gender: isEmpty(this.state.gender) ? null : this.state.gender,
			});
			this.setState({ isSearching: false, results: status.records });
		} catch (e) {
			this.setState({ isSearching: false });
		}
	};

	handleFirstNameChange = ({ target }) => {
		this.setState({ firstName: target.value });
	};

	handleLastNameChange = ({ target }) => {
		this.setState({ lastName: target.value });
	};

	handleDOBChange = ({ target }) => {
		// format from browser is YYYY-MM-DD
		this.setState({ dob: target.value });
	};

	handleGenderSelect = ({ target }) => {
		this.setState({ gender: target.value });
	};

	isValid = () => {
		const { lastName, dob, gender } = this.state;
		return !isEmpty(lastName) && !isEmpty(dob) && !isEmpty(gender);
	};

	render() {
		const { firstName, lastName, dob, gender, isSearching, results } =
			this.state;
		return (
			<div className="content-wrapper acrs-search">
				<form role="form">
					<div className="panel panel-default">
						<div className="panel-body row">
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor="input-fname" className="sr-only">
										First Name
									</label>
									<input
										id="input-fname"
										type="text"
										placeholder="First Name"
										className="form-control"
										onChange={this.handleFirstNameChange}
										value={firstName}
									/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor="input-lname" className="sr-only">
										Last Name
									</label>
									<input
										id="input-lname"
										type="text"
										placeholder="Last Name"
										className="form-control"
										onChange={this.handleLastNameChange}
										value={lastName}
									/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor="input-dob" className="sr-only">
										Date of Birth
									</label>
									<input
										id="input-dob"
										type="date"
										className="form-control"
										onChange={this.handleDOBChange}
										value={dob}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<Select
									selectedValue={gender}
									options={GENDER_CHOICES}
									onChange={this.handleGenderSelect}
								/>
							</div>
							<div className="col-md-1">
								<Button
									title="Search"
									primary
									onClick={this.handleSearchClick}
									disabled={!this.isValid() || isSearching}
								/>{' '}
								{isSearching && <em className="fa fa-spin fa-circle-o-notch" />}
							</div>
						</div>
					</div>
				</form>
				<table className="table table-striped table-bordered table-hover">
					<thead>
						<tr>
							<th>Patient</th>
							<th>Physician</th>
							<th>Practice</th>
							<th>Organization</th>
						</tr>
					</thead>
					<tbody>
						{!results && (
							<tr>
								<td colSpan="4">
									Please enter a patients Last Name, Date of Birth, and Gender
									and click Search
								</td>
							</tr>
						)}
						{results && results.length === 0 && (
							<tr>
								<td colSpan="4">No results found</td>
							</tr>
						)}
						{results &&
							results.length > 0 &&
							results.map((record) => (
								<tr key={`${record.relationid}`}>
									<td>
										{record.lastname}, {record.firstname} {record.middleinitial}
										{!isEmpty(record.suffix) && `, ${record.suffix}`}
									</td>
									<td>
										{record.physicianfirstname} {record.physicianlastname}
									</td>
									<td>{record.practicename}</td>
									<td>{record.organizationname}</td>
								</tr>
							))}
					</tbody>
				</table>
			</div>
		);
	}
}
